// @ts-nocheck
/* eslint-disable */
import { buildRadioCheck, icon, node, text } from "~/util/dom";

/**
 * Vytvoří textový node
 * @param {String} txt text
 * @returns {HTMLTextNode}
 */
Mapy.Util.text = function(txt, doc = document) {
	return text(txt, doc);
};

/**
 * Vytvoří HTML node
 * @param {String} name název tagu
 * @param {object} attrs vlastnosti, které se nodu nastaví
 * @param {String} content textový obsah nodu
 * @param {Document} doc dokument, v jehož kontextu pracujeme
 * @returns {HTMLElement}
 */
Mapy.Util.node = function(name, attrs, content = "", doc = document) {
	return node(name, attrs, content, doc);
};

/**
 * Vytvoří fragment node
 * @param {Document} doc dokument, v jehož kontextu pracujeme
 * @returns {DocumentFragment}
 */
Mapy.Util.fragment = function(doc = document) {
	return doc.createDocumentFragment();
}

/**
 * Vyčistí node od jakéhokoliv obsahu
 * @param {HTMLElement} node node k vyčištění
 */
Mapy.Util.clear = function(node) {
	while (node.firstChild) { node.firstChild.remove(); }
	return node;
};

/**
 * Vytvoří tlačítko
 * @param {object} attrs vlastnosti, které se nodu nastaví
 * @param {String} content textový obsah nodu
 * @param {Document} doc dokument, v jehož kontextu pracujeme
 * @returns {HTMLButtonElement} instance buttonu
 */
Mapy.Util.button = function(attrs, content, doc = document) {
	var result = Mapy.Util.node("button", attrs, content, doc);
	if (attrs && attrs.icon) {
		var i = icon(attrs.icon, undefined, doc);
		result.insertBefore(i, result.firstChild);
	}
	return result;
};

/**
 * Vytvoří checkbox nebo radiobutton
 * @param {String} type checkbox nebo radio
 * @param {String} title name pro formulářový prvek
 * @param {String} text text popisku (tedy obsah labelu)
 * @returns {object} objekt s vlastnostmi label, input a title (reprezentují HTML elementy)
 */
Mapy.Util.buildRadioCheck = function (type, name, text, doc = document) {
	return buildRadioCheck(type, name, text, doc);
};
